jQuery( document ).ready(function($) {
    // slides
    if (!$('body').hasClass('wp-admin')) {
        var mediumBreakpoint = parseInt(getComputedStyle(document.body).getPropertyValue('--uk-breakpoint-m')) <= $(window).width();

        var entries1 = $('.ct_ticker .template .l1 div');
        var line1 = $('<div class="marquee line1"></div>');

        if (mediumBreakpoint) {
            CreateDesktopSlider();
        }
        else {
            CreateMobileSlider();
        }

        InitializeSlider(mediumBreakpoint);
    }

    function CreateMobileSlider() {
        entries1.each(function (index) {
            line1.append($(this).clone());
            $('.ct_ticker .animationContainer').append(line1);
        });
    }

    function CreateDesktopSlider() {
        entries1.each(function (index) {
            line1.append($(this).clone());
        });

        $('.ct_ticker .animationContainer').append(line1);
    }
    function InitializeSlider(isDesktop) {
        var autoPlay = true;
        var speed1 = 7500;
        var centerPadding = '20px';
        if (isDesktop) {
            speed1 = 7500;
            centerPadding = '50px';
        }

        $('.marquee.line1').slick({
            speed: speed1,
            autoplay: autoPlay,
            autoplaySpeed: 0,
            centerMode: true,
            cssEase: 'linear',
            slidesToShow: 1,
            slidesToScroll: 1,
            variableWidth: true,
            infinite: true,
            initialSlide: 1,
            arrows: false,
            pauseOnHover: false,
            pauseOnFocus: false,
            buttons: false,
            centerPadding: centerPadding
        });
    }
});